import type { MovementMenuService } from '../types';

function filterServices(services: MovementMenuService[], filter: string) {
  return services.filter(
    service =>
      service?.title?.toLowerCase()?.includes(filter) ||
      service?.description?.toLowerCase()?.includes(filter) ||
      service?.redirects?.some(redirect =>
        redirect?.title?.toLowerCase()?.includes(filter),
      ) ||
      service?.redirects?.some(redirect =>
        redirect?.description?.toLowerCase()?.includes(filter),
      ),
  );
}

function mapFilteredServices(services: MovementMenuService[], filter: string) {
  return services.map(service => {
    const redirects = service?.redirects.filter(
      redirect =>
        service?.title?.toLowerCase()?.includes(filter) ||
        service?.description?.toLowerCase()?.includes(filter) ||
        redirect?.title?.toLowerCase()?.includes(filter) ||
        redirect?.description?.toLocaleLowerCase()?.includes(filter),
    );
    return { ...service, redirects };
  });
}

export function filterAllServices(
  services: MovementMenuService[],
  filter: string,
) {
  const filteredServices = filterServices(services, filter);

  return mapFilteredServices(filteredServices, filter);
}
